import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { UserProvider } from './components/userContext';
import { theme } from './styles/theme';
import Main from './components/main';

const App = () => (
  <React.Fragment>
    <ThemeProvider theme={theme}>
      <UserProvider>
        <Main />
      </UserProvider>  
    </ThemeProvider>
  </React.Fragment>
);

export default App;